export function resolveFavoriteMenuItems(favorites, blocks) {
  const items = (blocks || []).flatMap((block) => block.items || [])
  const itemsById = new Map(items.map((item) => [item.id, item]))
  const itemsByMenuKey = new Map()
  items.forEach((item) => {
    const bucket = itemsByMenuKey.get(item.menuKey) || []
    bucket.push(item)
    itemsByMenuKey.set(item.menuKey, bucket)
  })

  const usedIds = new Set()
  const resolved = []
  ;(favorites || []).forEach((favorite) => {
    let item = favorite?.menuItemId ? itemsById.get(favorite.menuItemId) : null
    if (!item && favorite?.menuKey) {
      item = (itemsByMenuKey.get(favorite.menuKey) || []).find((candidate) => !usedIds.has(candidate.id))
    }
    if (!item || usedIds.has(item.id)) return
    usedIds.add(item.id)
    resolved.push(item)
  })
  return resolved
}